const { DEVICE_KINDS, DEVICE_MFGS } = require('../constants');
const { updateLength } = require('./arithmetic');
const { deviceChargeStatus, deviceKind, deviceMfg, deviceSubBrand } = require('./print');

function deviceFilters(input, filterBy) {
  if (typeof filterBy === 'undefined') {
    return input;
  }

  const out = [];
  input.forEach((item) => {
    let include = true;
    Object.keys(filterBy).forEach((key) => {
      const values = filterBy[key];
      if (key === 'kind' && values == null) {
        include = item.kind != null ? false : include;
      } else if (key === 'kind' && values === 'free') {
        include = item.house == null ? true : include;
      } else if (key === 'kind' && values === 'other') {
        include = item.kind == null ? true : include;
      } else if (key === 'kind' && Array.isArray(values)) {
        include = values.includes(item.kind);
      } else if (key === 'free') {
        include = values === '0' || values === 'false' ? item.house : !item.house;
      } else if (values == null) {
        // pass it.
      } else if (item[key] && item[key].constructor === Array) {
        include = item[key].indexOf(values) === -1 ? false : include;
      } else if (values.length && values.length === 2) {
        include = item[key] < Number(values[0]) || item[key] >= Number(values[1]) ? false : include;
      } else if (!Number.isNaN(Number(values))) {
        include = item[key] !== Number(values) ? false : include;
      } else {
        include = item[key] !== values ? false : include;
      }
    });
    if (include) {
      out.push(item);
    }
  });
  return out;
}

function deviceNameFilter(device) {
  if (device.name) {
    return device.name;
  }
  const defaultName = `${DEVICE_MFGS[device.mfg] ? DEVICE_MFGS[device.mfg] : 'Unknown'} ${DEVICE_KINDS[device.kind] ? DEVICE_KINDS[device.kind] : 'Device'}`;
  return defaultName;
}

function id2name(id, nameList) {
  const item = nameList.find((name) => {
    return name.id === id;
  });

  return item ? item.name : '--';
}

function maxWidth(value, maxLength) {
  if (typeof value !== 'string') {
    return value;
  }
  let output = value;
  if (value.length > Math.abs(maxLength)) {
    output = maxLength > 0 ? value.slice(0, maxLength) : value.slice(maxLength);
    output = maxLength > 0 ? `${output}...` : `...${output}`;
  }
  return output;
}

module.exports = {
  deviceChargeStatus,
  deviceFilters,
  deviceKind,
  deviceMfg,
  deviceSubBrand,
  deviceNameFilter,
  id2name,
  maxWidth,
  updateLength,
};
